import { Component, OnInit, Input } from "@angular/core";
import { ToastController } from "@ionic/angular";

@Component({
  selector: "app-add-bookmark",
  templateUrl: "./add-bookmark.component.html",
  styleUrls: ["./add-bookmark.component.scss"],
})
export class AddBookmarkComponent implements OnInit {
  @Input() pageTitle: string;
  @Input() url: string;

  constructor(private toastController: ToastController) {}

  ngOnInit() {}

  async addToBookmarks() {
    let bookmarksPages = JSON.parse(localStorage.getItem("bookmarks") || "[]");
    let newBookmarks = bookmarksPages.filter((a) => {
      return a.url == `${this.url}`;
    });
    if (newBookmarks.length > 0) return;

    bookmarksPages.push({
      title: this.pageTitle,
      url: this.url,
    });
    localStorage.setItem("bookmarks", JSON.stringify(bookmarksPages));

    const toast = await this.toastController.create({
      message: "Pagina aggiunta ai segnalibri",
      duration: 3000,
    });
    toast.present();
  }
}
